<ng-container>
  <mat-form-field [formGroup]="form">
    <mat-label>
      {{ label | translate}}
    </mat-label>
    <mat-chip-grid #chipGrid>
      <mat-chip-row
        *ngFor="let input of inputs; let i = index" [removable]="'true'" (removed)="removeInputChip(i)" class="basic-text-chip"
        [class.chip--error-700]="!validateFn(input)"
      >
        {{ input }}
        <button matChipRemove>
          <ion-icon name="close"></ion-icon>
        </button>
      </mat-chip-row>

      <input
        matInput
        formControlName="input"
        [matChipInputFor]="chipGrid"
        [matChipInputAddOnBlur]="true"
        [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
        (matChipInputTokenEnd)="addChip($event)"
        (paste)="pasteEmailList($event)"
        [placeholder]="placeholder | translate"
      >
    </mat-chip-grid>
    <mat-error *ngIf="getChipForm.length > 0">{{ (errorMessage ? errorMessage: '') | translate }}</mat-error>
  </mat-form-field>
  <mat-hint *ngIf="!invalidInput" class="grey-color-500"> {{ (hintMessage ? hintMessage : '') | translate}}</mat-hint>

  <mat-error *ngIf="invalidInput">{{ (errorMessage ? errorMessage: '') | translate }}</mat-error>
</ng-container>
